import { CircularProgress as MuiCircularProgress } from '@mui/material';
import type { CircularProgressProps } from '@mui/material';

export const CircularProgress = (props: CircularProgressProps) => (
  <MuiCircularProgress color='secondary' {...props} />
);
